///
/// EarthBrowser
///
/// Migration v32 to v33: Add city label and weather visibility
/// Created by Matt Giger on 9/11/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v32 to v33
 *
 * Changes:
 * - Appends "location" (city name labels) and "city_weather" (weather chips
 *   on labels) to earthbrowser.visibleDatasets. These displays were always on
 *   before they became toggleable from the Layers panel, so existing users
 *   keep the previous behavior with both switches defaulting to on.
 */
interface StateV32 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

export function migrateV32toV33(state: unknown): unknown {
	const s = state as StateV32 | null | undefined
	if (!s?.earthbrowser || !Array.isArray(s.earthbrowser.visibleDatasets)) return state

	const visibleDatasets = [...s.earthbrowser.visibleDatasets]
	for (const type of ["location", "city_weather"]) {
		if (!visibleDatasets.includes(type)) {
			visibleDatasets.push(type)
		}
	}

	return {
		...s,
		earthbrowser: {
			...s.earthbrowser,
			visibleDatasets,
		},
	}
}
